module.exports = __webpack_public_path__ + "static/media/google_button.db9b21a1.png";